import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BuildingFilterModel } from '../../models/building-filter.model';
import { LanguageType } from '../../models/enum.model';
import { FilterBuildings } from '../../ngxs/action/building.action';
import { GetDashboard } from '../../ngxs/action/dashboard.action';
import { BuildingState } from '../../ngxs/state/building.state';
import { FilterService } from '../../services/filter.service';
import { LocalizationService } from '../../services/localization.service';
import { AccountInfo } from './../../models/accountInfo.model';
import { AccountState } from './../../ngxs/state/account.state';
import { AuthService } from './../../services/auth.service';
import { ChangePasswordComponent } from './../change-password/change-password.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  subscription = new Subscription();
  @Input()
  isAuthorized = false;

  @Output()
  toggleSideBarForMe: EventEmitter<any> = new EventEmitter();
  toggled = true;

  @Select(AccountState.isAuthorized)
  isAuthorized$: Observable<boolean>;

  @Select(AccountState.account)
  account$: Observable<AccountInfo>;

  @Select(BuildingState.filter)
  filter$: Observable<BuildingFilterModel>;

  currentFilter: BuildingFilterModel;

  language = '';

  relihUrl = environment.relihUrl;
  habitatUrl = environment.habitatUrl;

  public accountInfo: AccountInfo = new AccountInfo();
  constructor(
    private dialog: MatDialog,
    private store: Store,
    private translateService: TranslateService,
    private router: Router,
    private authService: AuthService,
    private localizationService: LocalizationService,
    private filterService: FilterService
  ) {}

  ngOnInit(): void {
    this.language = this.translateService.getDefaultLang();
    this.currentFilter = new BuildingFilterModel(
      [],
      [],
      '',
      '',
      [],
      0,
      0,
      LanguageType[this.language.toUpperCase()]
    );
    this.subscribeEvents();
  }

  subscribeEvents() {
    this.subscription.add(
      this.account$.subscribe((x) => {
        if (x) {
          this.accountInfo.email = x.email;
          this.accountInfo.firstName = x.firstName;
          this.accountInfo.lastName = x.lastName;
        }
      })
    );
    this.subscription.add(
      this.filter$.subscribe((x) => {
        if (x) {
          this.currentFilter = x;
        }
      })
    );
  }

  toggleSidebar() {
    this.toggled = !this.toggled;
    this.toggleSideBarForMe.emit();
  }

  switchLang(lang: string) {
    this.localizationService.setLanguage(lang);
    this.language = lang;
    this.store.dispatch(new GetDashboard(lang));
    this.store.dispatch(
      new FilterBuildings(
        this.filterService.generateHttpParams(),
        new BuildingFilterModel(
          this.currentFilter.municipalities,
          this.currentFilter.periods,
          this.currentFilter.street,
          this.currentFilter.streetNumber,
          this.currentFilter.types,
          this.currentFilter.searchLatitude,
          this.currentFilter.searchLongitude,
          LanguageType[lang.toUpperCase()]
        )
      )
    );
  }

  getLanguages() {
    return this.translateService.getLangs();
  }

  currentLanguge() {
    return this.translateService.currentLang;
  }

  openChangePassword() {
    this.dialog.open(ChangePasswordComponent, {});
  }

  getFlagClass(item) {
    if (item?.toLowerCase() == 'mk') {
      return 'fi fi-mk flag-icon';
    } else {
      return 'fi fi-us flag-icon';
    }
  }

  logout() {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
